// extracted by mini-css-extract-plugin
export default {"text":"ProjectHelpPage1_text__29w7T","imageArrow":"ProjectHelpPage1_imageArrow__sq1s5"};